import { Component } from '@angular/core';

@Component({
  selector: 'app-dnq-reports',
  templateUrl: './dnq-reports.component.html',
  styleUrls: ['./dnq-reports.component.scss']
})
export class DNQReportsComponent {

}
